import { Badge } from "@/components/ui/badge";
import { ReviewStatus } from "@/hooks/useAdminReviews";
import { Clock, CheckCircle, XCircle } from "lucide-react";

interface ReviewStatusBadgeProps {
  status: ReviewStatus;
}

const ReviewStatusBadge = ({ status }: ReviewStatusBadgeProps) => {
  const configs = {
    pending: {
      label: "Pending",
      variant: "secondary" as const,
      icon: Clock,
      className: "bg-yellow-500/10 text-yellow-600 dark:text-yellow-400 border-yellow-500/20",
    },
    approved: {
      label: "Approved",
      variant: "default" as const,
      icon: CheckCircle,
      className: "bg-green-500/10 text-green-600 dark:text-green-400 border-green-500/20",
    },
    rejected: {
      label: "Rejected",
      variant: "destructive" as const,
      icon: XCircle,
      className: "bg-red-500/10 text-red-600 dark:text-red-400 border-red-500/20",
    },
  };

  const config = configs[status];
  const Icon = config.icon;

  return (
    <Badge variant={config.variant} className={`flex items-center gap-1 ${config.className}`}>
      <Icon className="h-3 w-3" />
      {config.label}
    </Badge>
  );
};

export default ReviewStatusBadge;
